import React, { useEffect } from 'react';

const FontSizeChanger = ({ fontSize, setFontSize }) => {
  useEffect(() => {
    const savedFontSize = parseInt(localStorage.getItem("codeEditorFontSize")) || 16;
    setFontSize(savedFontSize);
  }, [setFontSize]);

  const handleFontSizeChange = (event) => {
    const diff = event.currentTarget.value === '-' ? -1 : 1;
    const newFontSize = fontSize + diff;

    if (newFontSize < 8 || newFontSize > 100) return;

    setFontSize(newFontSize);
    localStorage.setItem('codeEditorFontSize', newFontSize);
  };

  return (
    <div
      className="
        inline-flex items-center overflow-hidden rounded-full
        bg-slate-100/90 shadow-sm ring-1 ring-slate-200
      "
    >
      <button
        type="button"
        className="
          flex h-10 w-10 items-center justify-center
          bg-emerald-700 text-xl font-bold leading-none text-white
          transition hover:bg-emerald-600 active:scale-95
          focus:outline-none focus:ring-2 focus:ring-emerald-300
        "
        onClick={handleFontSizeChange}
        value="-"
        aria-label="Decrease font size"
      >
        -
      </button>

      <span
        className="
          min-w-[42px] px-3 text-center
          text-base font-semibold text-slate-700
        "
      >
        {fontSize}
      </span>

      <button
        type="button"
        className="
          flex h-10 w-10 items-center justify-center
          bg-emerald-700 text-xl font-bold leading-none text-white
          transition hover:bg-emerald-600 active:scale-95
          focus:outline-none focus:ring-2 focus:ring-emerald-300
        "
        onClick={handleFontSizeChange}
        value="+"
        aria-label="Increase font size"
      >
        +
      </button>
    </div>
  );
};

export default FontSizeChanger;